module.exports = __webpack_public_path__ + "img/popup-bottom-battery-0.146b0cce.svg";